import getPayPalLink from './getPayPalLink';

export default getPayPalLink;
